import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageShell from "../dashboard/PageShell";

const AddProductTypeIII: React.FC = () => {
  const navigate = useNavigate();
  const id = useMemo(() => {
    try {
      const parts = window.location.pathname.split("/").filter(Boolean);
      // expecting .../completed-projects/detail/:id/products/type3/add
      const idx = parts.indexOf("detail");
      return idx >= 0 && parts[idx + 1] ? parts[idx + 1] : "";
    } catch {
      return "";
    }
  }, []);

  const [formData, setFormData] = useState({
    title: "",
    journalType: "",
    journalCategory: "",
    mainAuthor: "Lê Anh Tuấn",
    mainAuthorName: "Thượng tá, VS. ThS Lê Anh Tuấn",
    coAuthors: "",
    journalName: "",
    journalNumber: "",
    journalPage: "",
    month: "",
    year: "",
    rewardAmount: "",
    transferToPublished: false,
    attachment: null as File | null,
  });

  const handleChange = (
    field: string,
    value: string | boolean | File | null
  ) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = () => {
    console.log("Save product type III:", { projectId: id, ...formData });
    window.history.back();
  };

  return (
    <PageShell title="Thêm tạp chí trong nước, quốc tế">
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">
            Thêm tạp chí trong nước, quốc tế
          </h1>
        </div>

        <div className="bg-white rounded-lg shadow overflow-hidden">
          <div className="p-6 space-y-5">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Tên bài báo, công trình{" "}
                  <span className="text-red-500">(*)</span>
                </label>
                <input
                  type="text"
                  value={formData.title}
                  onChange={(e) => handleChange("title", e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập tên bài báo, công trình..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Loại tạp chí <span className="text-red-500">(*)</span>
                </label>
                <select
                  value={formData.journalType}
                  onChange={(e) => handleChange("journalType", e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">- Chọn -</option>
                  <option value="quoc-te">Tạp chí quốc tế</option>
                  <option value="trong-nuoc">Tạp chí trong nước</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Danh mục của tạp chí <span className="text-red-500">(*)</span>
                </label>
                <select
                  value={formData.journalCategory}
                  onChange={(e) =>
                    handleChange("journalCategory", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">- Chọn -</option>
                  <option value="scopus">Tạp chí Scopus</option>
                  <option value="isi">Tạp chí ISI</option>
                  <option value="quoc-gia">Tạp chí quốc gia</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Chọn tác giả chính <span className="text-red-500">(*)</span>
                </label>
                <select
                  value={formData.mainAuthor}
                  onChange={(e) => handleChange("mainAuthor", e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="Lê Anh Tuấn">Lê Anh Tuấn</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Tên tác giả chính <span className="text-red-500">(*)</span>
                </label>
                <input
                  type="text"
                  value={formData.mainAuthorName}
                  onChange={(e) =>
                    handleChange("mainAuthorName", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Đồng tác giả
                </label>
                <input
                  type="text"
                  value={formData.coAuthors}
                  onChange={(e) => handleChange("coAuthors", e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập tên đồng tác giả..."
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Tên tạp chí
                </label>
                <input
                  type="text"
                  value={formData.journalName}
                  onChange={(e) => handleChange("journalName", e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập tên tạp chí..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Số tạp chí
                </label>
                <input
                  type="text"
                  value={formData.journalNumber}
                  onChange={(e) =>
                    handleChange("journalNumber", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập số tạp chí..."
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Trang tạp chí
                </label>
                <input
                  type="text"
                  value={formData.journalPage}
                  onChange={(e) => handleChange("journalPage", e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập trang tạp chí..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Tháng
                </label>
                <select
                  value={formData.month}
                  onChange={(e) => handleChange("month", e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">- Chọn -</option>
                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {i + 1}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Năm công bố
                </label>
                <select
                  value={formData.year}
                  onChange={(e) => handleChange("year", e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">- Chọn -</option>
                  {Array.from({ length: 10 }, (_, i) => {
                    const year = new Date().getFullYear() - i;
                    return (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Số tiền khen thưởng
                </label>
                <input
                  type="text"
                  value={formData.rewardAmount}
                  onChange={(e) => handleChange("rewardAmount", e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập số tiền khen thưởng..."
                />
              </div>
            </div>

            <div className="flex items-center">
              <input
                type="checkbox"
                id="transferToPublished"
                checked={formData.transferToPublished}
                onChange={(e) =>
                  handleChange("transferToPublished", e.target.checked)
                }
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <label
                htmlFor="transferToPublished"
                className="ml-2 block text-sm text-gray-700"
              >
                Chuyển thông tin bài báo đến Mục bài báo đã công bố
              </label>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                File đính kèm
              </label>
              <div className="flex items-center gap-2">
                <input
                  type="file"
                  onChange={(e) =>
                    handleChange("attachment", e.target.files?.[0] || null)
                  }
                  className="hidden"
                  id="file-upload"
                />
                <label
                  htmlFor="file-upload"
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 cursor-pointer"
                >
                  Choose Files
                </label>
                <span className="text-sm text-gray-500">
                  {formData.attachment
                    ? formData.attachment.name
                    : "No file chosen"}
                </span>
              </div>
            </div>

            <div className="flex justify-end gap-2 pt-2">
              <button
                onClick={() => window.history.back()}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50"
              >
                Hủy
              </button>
              <button
                onClick={handleSave}
                className="bg-[#337ab7] hover:bg-[#2e6da4] text-white px-4 py-2 rounded text-sm font-medium"
              >
                Lưu
              </button>
            </div>
          </div>
        </div>
      </div>
    </PageShell>
  );
};

export default AddProductTypeIII;
